class Cookie {
    constructor() {
        
    }

    get(name) {
        let matches = document.cookie.match(new RegExp(
            "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
        ));

        return matches ? decodeURIComponent(matches[1]) : undefined;
    }

    set(name, value, options = {}, days = 365) {
        const date = new Date();
        const timer = 24 * 60 * 60 * 1000 * days;

        date.setTime(date.getTime() + timer);

        options = {
            path: '/',
            expires: date,
            ...options
        };
        
        if (options.expires instanceof Date) {
            options.expires = options.expires.toUTCString();
        }
        
        let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);
        
        for (let optionKey in options) {
            updatedCookie += "; " + optionKey;

            let optionValue = options[optionKey];

            if (optionValue !== true) {
                updatedCookie += "=" + optionValue;
            }
        }
        
        document.cookie = updatedCookie;
    }

    deleteCookie(name) {
        set(name, '', {
            'max-age': -1
        });
    }
}

const cookie = new Cookie;

(function() {
    const popupCloseButtons = document.querySelectorAll('.js-popup-close');

    popupCloseButtons.forEach(button => {
        button.addEventListener('click', (event) => {
            event.preventDefault();
            cookie.set(button.dataset.popupNamespace, '');

            const popup = button.closest('.popups__block');

            popup.classList.remove('popups__block--show');
        });
    });

    setTimeout(() => {
        if(window.hidePopups) {
            window.hidePopups.forEach(namespace => cookie.set(namespace, ''));
            window.hidePopups = null;
        }

        popupCloseButtons.forEach(button => {
            const cookieValue = cookie.get(button.dataset.popupNamespace);
            const urlCall = button.dataset.urlCall;

            if(cookieValue === undefined || window.location.href.indexOf(urlCall) !== -1) {
                const popup = button.closest('.popups__block');
    
                popup.classList.add('popups__block--show');
            }
        });
    }, window.popupsDelay * 1000);
})();